export default "__VITE_ASSET__vi7L2ahj__"